// @flow
import {logExperiment} from '@homeaway/abacus-client-utils';

import type {
    AbacusEvaluationData,
    State as AbacusState
} from '../../reducers/abacus';

export type ExperimentValue = number | number[];

export default class AbacusContext {
    abacus: AbacusState;
    evaluatedExperiments: {[string]: boolean};

    constructor(abacus: AbacusState = {}) {
        this.abacus = abacus;
        this.evaluatedExperiments = {};
    }

    evaluationIsVariant(
        evaluationData?: AbacusEvaluationData,
        variant?: ExperimentValue
    ) {
        if (evaluationData) {
            if (Array.isArray(variant)) {
                return variant.indexOf(evaluationData.value) !== -1;
            }
            return evaluationData.value === variant;
        }

        return variant === 0;
    }

    evaluationIsOn(evaluationData?: AbacusEvaluationData) {
        return evaluationData && evaluationData.value > 0;
    }

    logExperimentOnce(evaluationData: AbacusEvaluationData) {
        const {
            experimentKey: {experimentName}
        } = evaluationData;
        if (!this.evaluatedExperiments[experimentName]) {
            logExperiment(evaluationData);
            this.evaluatedExperiments[experimentName] = true;

            // istanbul ignore next
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.info(
                    `%cLogged experiment: %c${
                        evaluationData.experimentKey.experimentName
                    } {${evaluationData.value}}`,
                    'font-weight: bold',
                    'font-weight: normal'
                );
            }
        }
    }
}

export type AbacusContextType = AbacusContext;
